export default "__VITE_ASSET__Jeu2ZNbO__"